import BaseComponent from 'scripts/BaseComponent.js';
import axios from 'axios';
import Swiper, { Navigation } from 'swiper';

export default class ProductRecommendations extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-swiperContainer',
      swiperWrapper: '.js-swiperWrapper',
      productRecommendationsData: '.js-productRecommendationsData',
      prevSlideBtn: '.js-prevSlideBtn',
      nextSlideBtn: '.js-nextSlideBtn',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $swiperWrapper: this.$get(this.refs.swiperWrapper),
      $prevSlideBtn: this.$get(this.refs.prevSlideBtn),
      $nextSlideBtn: this.$get(this.refs.nextSlideBtn),
    };

    this.state = {
      swiper: null,
      mountProductsEvent: 'mountproductcards',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom } = this;

    if (dom.$component.dataset.productId) {
      this.getRecommendations();
      return;
    }

    this.initSlider();
  }

  async getRecommendations() {
    const { dom, state, refs } = this;
    const { productId } = dom.$component.dataset;
    const url = `/recommendations/products?product_id=${productId}&limit=8&section_id=product-recommendations`;

    try {
      const res = await axios.get(url);
      const parser = new DOMParser();
      const page = parser.parseFromString(res.data, 'text/html');
      const slides = page.querySelector(refs.productRecommendationsData);
      dom.$swiperWrapper.innerHTML = slides.innerHTML;
      this.initSlider();
      this.dispatch(state.mountProductsEvent);
    } catch (e) {
      console.log('Error getting product recommendations', e);
    }
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation],
      loop: false,
      slidesPerView: 2,
      threshold: 5,
      navigation: {
        prevEl: dom.$prevSlideBtn,
        nextEl: dom.$nextSlideBtn,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}
